import { init } from '@/service/generic.service';

const methods = init({ collectionPath: 'commonLists' });

export default { ...methods };
